<template>
    <div class="error-page">
        <div class="error-page__inner">
            <p v-if="showText" class="error-page__text">{{ text }}</p>
            <p v-else class="error-page__text">Loading...</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErrorPage',
    data: function() {
        return {
            showText: false,
            timeoutId: null
        };
    },
    mounted() {
        this.timeoutId = setTimeout(() => {
            this.showText = true;
        }, 5000);
    },
    unmounted() {
        clearTimeout(this.timeoutId);
    },
    computed: {
        text() {
            return (
                this.$route.params.text || 'Technical error occurred, please reload the page later'
            );
        }
    }
};
</script>

<style lang="scss" src="./ErrorPage.scss"></style>
